export const DEFAULT_SECONDS_RULER = 60;
export const RULER_EXTRA_PIXEL = 10;
export const SECONDS_LENGTH = 10;
export const SECONDS_CHUNKS = 10;